import { render, staticRenderFns } from "./ShowMessage.vue?vue&type=template&id=01ecd53d&"
import script from "./ShowMessage.vue?vue&type=script&lang=js&"
export * from "./ShowMessage.vue?vue&type=script&lang=js&"
import style0 from "./ShowMessage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01ecd53d')) {
      api.createRecord('01ecd53d', component.options)
    } else {
      api.reload('01ecd53d', component.options)
    }
    module.hot.accept("./ShowMessage.vue?vue&type=template&id=01ecd53d&", function () {
      api.rerender('01ecd53d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageAgentSub/ShowMessage.vue"
export default component.exports